export default "__VITE_ASSET__CEWNqQSU__"